import {
  Component,
  ChangeDetectionStrategy,
  Input,
  HostBinding,
} from '@angular/core';

import { GasNotification } from '../gas-notify.namespace';
import { GasIcon } from '../../../utils/gas-icons/icon/gas-icon.namespace';
import { GasNotificationService } from '../gas-notify.service';
import { fadeInOutUpAnimation } from '../../../core/animations/fade-in-out.animation';

/** @see https://www.figma.com/file/yqBeq1MiGfpdN62SvmA8tg/RTLABS_GAS_DS_1?node-id=2983%3A1585 */
@Component({
  selector: 'gas-notify-bar',
  templateUrl: './gas-notify-bar.component.html',
  styleUrls: ['./gas-notify-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInOutUpAnimation,
  ],
})
export class GasNotifyBarComponent {
  @Input()
  public notification: GasNotification.Notification;

  @HostBinding('@fadeInOutUpAnimation')
  public animation = true;

  @HostBinding('class')
  @Input()
  public get type(): string {
    return `_${this.notification.type}`;
  }

  public get closeIconName(): string {
    return this.notification.type.includes('light')
      ? GasIcon.Notifications.LightClose
      : GasIcon.Notifications.Close;
  }

  public get iconName(): GasIcon.Notifications {
    return GasNotification.getIcon(this.notification.type);
  }

  constructor(
    private gasNotificationService: GasNotificationService,
  ) {}

  public close(): void {
    this.gasNotificationService.closeNotification(this.notification.id);
  }

  public executeCallback(): void {
    this.notification.linkCallback();
    this.close();
  }
}
